import type { FilterConfigGroupItem } from '../FilterConfigTypes';

export const DTCGroupItems: Array<FilterConfigGroupItem> = [
  {
    groupLabel: 'Patient Attributes',
    ordinalPosition: 1,
    tooltip:
      'The Patient Attributes section provides filters to refine audience targeting based on specific characteristics related to patients. These attributes encompass various factors such as demographics, medical history, and clinical conditions. By utilizing the Patient Attributes section, users can tailor their outreach efforts to target healthcare professionals who treat patients with specific characteristics or conditions.',
    filtersInGroup: [
      { name: 'patient_gender_filter', index: 1 },
      { name: 'patient_age_range_filter', index: 2 },
      { name: 'patient_zipcode_filter', index: 3 },
      { name: 'patient_facility_state_name_filter', index: 4 },
      { name: 'patient_market_area_filter', index: 5 },
      { name: 'patient_insurance_provider_name_filter', index: 6 },
    ],
  },
  {
    groupLabel: 'Clinical Data',
    ordinalPosition: 2,
    tooltip:
      'The Clinical section provides a range of filters designed to refine audience targeting based on clinical factors related to healthcare professionals. These filters allow you to target individuals based on their prescription behavior, diagnostic practices, procedures performed, and related clinical activities. By utilizing the Clinical section, you can tailor your outreach efforts to reach healthcare professionals who have demonstrated specific clinical behaviors or expertise. This approach ensures that your messaging is highly relevant and resonates with the clinical interests and practices of your target audience.',
    filtersInGroup: [
      { name: 'prescription_filter', index: 1 },
      { name: 'procedure_filter', index: 2 },
      { name: 'diagnosis_filter', index: 3 },
    ],
  },
  {
    groupLabel: 'NPI Attributes',
    ordinalPosition: 2,
    tooltip:
      'The NPI Attributes section provides a suite of tools to refine your audience targeting based on specific attributes associated with healthcare professionals. These attributes cover various aspects such as demographics, education, specialization, and location. By utilizing the NPI Attributes section, you can tailor your outreach efforts to target healthcare professionals who match your desired criteria, ensuring your campaigns are highly relevant and effective.',
    filtersInGroup: [
      { name: 'profession_and_speciality_subgroup', index: 1 },
      { name: 'npi_list_name_filter', index: 2 },
    ],
  },
];
